// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".render-sort[data-v-08f64efa] {\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://assets/ui/render/render-sort-column.vue","webpack://render-sort-column.vue"],"names":[],"mappings":"AACA;EACE,eAAA;ACAF","sourcesContent":["\n.render-sort {\n  cursor: pointer;\n}\n",".render-sort {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
